import UnicoUtils from "./script-utils.js";

/**
 * 商品詳細ページのオーダー情報の選択パーツ
 */
export default class CustomRadioButton extends HTMLElement {
  constructor() {
    super();

    const buttonList = this.querySelectorAll(
      'unico-radio-button:not([data-set-custom]) button',
    );

    buttonList.forEach((button, index) => {
      button.addEventListener('click', async (e) => {
        WLCommon.enableLoading();

        buttonList.forEach((button) => {
          button.setAttribute('aria-checked', 'false');
        });
        buttonList[index].setAttribute('aria-checked', 'true');
        if (e.target.hasAttribute('data-order-select')) {
          WLCommon.disableLoading();
          return;
        }

        this.productInformaition = JSON.parse(
          document.querySelector('#wl-product-information').textContent,
        );
        this.product = this.productInformaition.product;
        this.productVariants = this.productInformaition.variants;
        this.productMetafields = this.productInformaition.product_metafields;
        this.variantMetafields = this.productInformaition.variant_metafields;
        this.sectionId = document.querySelector(
          'unico-product-detail',
        ).dataset.id;

        const variant = this.variantSelector();

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('variant', variant.id);
        window.history.replaceState(
          {},
          '',
          `${window.location.pathname}?${searchParams.toString()}`,
        );

        searchParams.set('section_url', location.href);
        searchParams.set('sections', this.sectionId);
        this.section = await this.getSectionRender(searchParams);
        this.sectionRender();

        // カラー切り替えのラジオボタンか？
        const isColorButton = this.classList && this.classList.contains('unico-product-select-color');

        // バリエーションの切り替えタイミングでスクロール（SPのみ）
        if (UnicoUtils.isSP() && isColorButton) {
          const target = document.querySelector('.unico-section-inner.unico-section-detail-contents');
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }

        WLCommon.disableLoading();
      });
    });
  }
  sectionRender() {
    const dom = new DOMParser().parseFromString(this.section, 'text/html');
    document.querySelector('unico-product-image').outerHTML = dom.querySelector(
      'unico-product-image',
    ).outerHTML;
    document.querySelector('.unico-product-order').outerHTML =
      dom.querySelector('.unico-product-order').outerHTML;

    document.querySelector('.unico-bottom-menu').outerHTML =
      dom.querySelector('.unico-bottom-menu').outerHTML;

    document.querySelector(
      'unico-product-detail .unico-product-price',
    ).outerHTML = dom.querySelector(
      'unico-product-detail .unico-product-price',
    ).outerHTML;

    document.querySelector('.unico-product-code').outerHTML = dom.querySelector('.unico-product-code').outerHTML;

    document.querySelector('#selectedVariants').outerHTML =
      dom.querySelector('#selectedVariants').outerHTML;

    if (document.querySelector('#wl-set-product-wrap')) {
        document.querySelector('#wl-set-product-wrap').outerHTML =
        dom.querySelector('#wl-set-product-wrap').outerHTML;
    }

    if (document.querySelector('wl-build-price')) {
      document.querySelector('wl-build-price').outerHTML =
        dom.querySelector('wl-build-price').outerHTML;
    }

    if (document.querySelector('wl-pre-order-info') && dom.querySelector('wl-pre-order-info')) {
      document.querySelector('wl-pre-order-info').outerHTML =
        dom.querySelector('wl-pre-order-info').outerHTML;
    }

    if (document.querySelector('unico-tab-contents')) {
      document.querySelector('unico-tab-contents').outerHTML =
        dom.querySelector('unico-tab-contents').outerHTML;
    }

    if (document.querySelector('unico-product-stock')) {
      document.querySelector('unico-product-stock').outerHTML =
        dom.querySelector('unico-product-stock').outerHTML;
    }

    // お届け日の差し替え
    const currentShippingDate = document.querySelector('.unico-product-delivery-block.shipping-date');
    const newShippingDate = dom.querySelector('.unico-product-delivery-block.shipping-date');
    const deliveryContainer = document.querySelector('.unico-product-delivery');
    const shippingTypeBlock = document.querySelector('.unico-product-delivery-block.shipping-type');
    if (currentShippingDate && newShippingDate) {
      currentShippingDate.outerHTML = newShippingDate.outerHTML;
    } else if (!currentShippingDate && newShippingDate) {
      if (shippingTypeBlock) {
        shippingTypeBlock.insertAdjacentElement('beforebegin', newShippingDate.cloneNode(true));
      } else if (deliveryContainer) {
        deliveryContainer.appendChild(newShippingDate.cloneNode(true));
      }
    } else if (currentShippingDate && !newShippingDate) {
      currentShippingDate.remove();
    }

    // 配送区分の差し替え
    if (document.querySelector('.unico-product-delivery-block.shipping-type')) {
      document.querySelector('.unico-product-delivery-block.shipping-type').outerHTML =
        dom.querySelector('.unico-product-delivery-block.shipping-type').outerHTML;
    }
    if (document.querySelector('.unico-product-frame-content')) {
      document.querySelector('.unico-product-frame-content').outerHTML =
        dom.querySelector('.unico-product-frame-content').outerHTML;
    }

      document.querySelector('unico-product-detail').initProductArea()

    // サンプル請求ボタンのイベントリスナーを再設定
    if (document.querySelector('#sample-request')) {
      WLPowerfulFormBuilder.productInit();
    }
  }
  getSectionRender(searchParams) {
    return new Promise((resolve, reject) => {
      fetch(location.pathname + '?' + searchParams.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((response) => resolve(response[this.sectionId]))
        .catch((error) => {
          console.error('Error:', error);
          reject(error);
        })
        .finally(() => {});
    });
  }
  variantSelector() {
    const targets = document.querySelectorAll(
      'unico-radio-button [aria-checked="true"]',
    );
    for (let target of targets) {
      this[target.getAttribute('data-target-option')] =
        target.getAttribute('data-value');
    }

    const variant = this.productVariants.find((variant) => {
      if (this.option1 && this.option2 && this.option3) {
        return (
          variant.option1 === this.option1 &&
          variant.option2 === this.option2 &&
          variant.option3 === this.option3
        );
      } else if (this.option1 && this.option2) {
        return (
          variant.option1 === this.option1 && variant.option2 === this.option2
        );
      } else if (this.option1) {
        return variant.option1 === this.option1;
      }
    });
    if(variant === undefined){
      return this.productVariants.find((variant) => variant.option1 === this.option1);
    }
    return variant;
  }
}
